import { useCallback } from "react";
import { AddToChatButton } from "../../AddToChatButton";
import { AskAboutInvoice } from "../../buildInvoiceReferences";
import { useAddInvoicesToChat } from "../../useAddReferencesToChat";

interface InvoicesTaskAskButtonProps {
    invoices: AskAboutInvoice[];
    onAsked: () => void;
}

/**
 * Attaches the selected invoices as chat references of the open task. Only
 * rendered inside a task context: it needs InvoiceRefProvider/TasksProvider.
 */
export const InvoicesTaskAskButton: React.FC<InvoicesTaskAskButtonProps> = ({
    invoices,
    onAsked,
}) => {
    const { canAddToChat, addInvoicesToChat } = useAddInvoicesToChat();

    const handleAttach = useCallback(() => {
        addInvoicesToChat(invoices);
        onAsked();
    }, [addInvoicesToChat, invoices, onAsked]);

    if (!canAddToChat || invoices.length === 0) {
        return null;
    }

    return (
        <AddToChatButton
            noun="invoice"
            count={invoices.length}
            onClick={handleAttach}
        />
    );
};
